import { render, staticRenderFns } from "./ProductSizeChart.vue?vue&type=template&id=1d1305a4&scoped=true&"
import script from "./ProductSizeChart.vue?vue&type=script&lang=js&"
export * from "./ProductSizeChart.vue?vue&type=script&lang=js&"
import style0 from "./ProductSizeChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductSizeChart.vue?vue&type=style&index=1&id=1d1305a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1305a4",
  null
  
)

export default component.exports